export default __webpack_public_path__ + "static/media/IconDesc_Stator.64.5acdb0ac.png";